import dayjs from "dayjs";

const formatDateShort = (date: any) => {
  if (date == undefined) {
    return "";
  }
  return dayjs(date).format("MM/DD/YYYY");
};

const formatToLLL = (date: any) => {
  if (date == undefined) {
    return "";
  }
  return dayjs(date).format("MMMM D, YYYY h:mm A");
};

const formatDateTime = (date: any) => {
  if (date == undefined) {
    return "";
  }
  return dayjs(date).format("M/DD/YY h:mm A");
};

const usdFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

const formatToUSD = (number: number | undefined) => {
  if (!number) return number;
  return usdFormat.format(number);
};

export { formatDateShort, formatToLLL, formatDateTime, formatToUSD };